import { Action, Reducer } from 'redux'
import * as GenModels from '../models/GenericModels';
import * as ServMasterModel from '../models/ServiceMasterModel';
import { BillToList, BillToModel, initialState as BillToInitialState, initialARInfoState } from '../models/BillToModel';
import { ApplicationState, AppThunkAction } from '.';
import { ServiceMaster } from '../models/ServiceMasterModel';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface LoadArInfo { type: 'BILLTO_LOAD', newState: BillToList }

export type KnownAction = LoadArInfo;

export const selectors = {
    getServiceMasterFromSelectedAR(AppState: ApplicationState): ServiceMaster[] {

        var SMList: ServiceMaster[] = [];
        if (AppState.sessionState !== undefined) {
            const AR: BillToModel = AppState.sessionState.SelectedAR;
            SMList = AR.serviceMasters;
        }

        return SMList;
    }
}

export const reducer: Reducer<BillToList> = (state: BillToList | undefined, incomingAction: Action): BillToList => {

    if (state === undefined) {
        return initialARInfoState;
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'BILLTO_LOAD':
            //console.log("LoadAR");            
            const loadARAction = incomingAction as LoadArInfo;            
            //console.log(loadARAction.newState);            
            return loadARAction.newState;      
        default:
            return state;
    }
}; 
